import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/**
 * The single open SLA clock for a PO, if any.  Used by the design
 * queue's TAT cell so the countdown reflects the live server-side
 * deadline (including Super Admin overrides and pause windows) instead
 * of recomputing locally on every render.
 */
export interface SlaInstance {
  instanceId: number;
  ruleId: number;
  processCode: string;
  processName: string;
  startedAt: string;
  deadlineAt: string;
  pausedAt: string | null;
  pausedTotalSec: number;
  completedAt: string | null;
  resultCode: string | null;
  snapshotSlaHours: number;
  snapshotTimeUnit: 'business_hours' | 'calendar_hours';
  ownerUserId: number | null;
}

export function useOpenSlaInstance(
  entityType: string,
  entityId: string | null | undefined,
  enabled = true,
  processCode?: string,
) {
  return useQuery({
    enabled: enabled && !!entityId,
    queryKey: ['sla-instance', entityType, entityId, processCode ?? ''],
    queryFn: async () => {
      let url = `/api/sla/instance?entityType=${encodeURIComponent(entityType)}&entityId=${encodeURIComponent(entityId!)}&open=1`;
      if (processCode) url += `&processCode=${encodeURIComponent(processCode)}`;
      const rows = await api<SlaInstance[]>(url);
      return rows[0] ?? null;
    },
    staleTime: 30_000,
  });
}
